import { defineStore } from "pinia";

export const useBookingStore = defineStore("booking", { 
  state: () => ({
    bookingRoom: null,
    confirmBookinDetails: null,
    isLoading: false,
  }),
  actions: {
    addValueToBookingRoom(value) {
      this.bookingRoom = value;
    },
    setConfirmBookinDetails(value) {
      this.confirmBookinDetails = value;
    },
    setLoading(payload) {
      this.isLoading = payload;
    }
  },
  getters: {
    getBookingRoomValue: (state) => state.bookingRoom,
    getConfirmBookinDetails: (state) => state.confirmBookinDetails,
    getLoading: (state) => state.isLoading
  },
});
